module.exports = __webpack_public_path__ + "static/img/android3.9643821a.jpg";